var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThecontact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.11 36.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff9500;}.cls-2{fill:none;stroke:#ff9500;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.32,21.51l-4-2.92L24.3,15.2a.57.57,0,0,0,.09-.71.4.4,0,0,0-.61-.1l-5.6,4.81h0l-5.6-4.81a.4.4,0,0,0-.61.1.56.56,0,0,0,.09.71l4,3.39-4,2.92a.56.56,0,0,0-.13.7.42.42,0,0,0,.36.24.46.46,0,0,0,.24-.08l4.26-3.13,1.16,1a.39.39,0,0,0,.52,0l1.16-1,4.26,3.13a.4.4,0,0,0,.23.08.43.43,0,0,0,.37-.24A.55.55,0,0,0,24.32,21.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.19,10.86H11.91c-1.8,0-3.26,1.86-3.26,4.14v6.11c0,2.28,1.46,4.14,3.26,4.14H24.19c1.81,0,3.27-1.86,3.27-4.14V15C27.46,12.72,26,10.86,24.19,10.86Zm2.2,10.25a2.54,2.54,0,0,1-2.2,2.78H11.91a2.54,2.54,0,0,1-2.19-2.78V15a2.55,2.55,0,0,1,2.19-2.79H24.19A2.55,2.55,0,0,1,26.39,15v6.11Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 18.05,
    cy: 18.05,
    r: 17.05
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThecontact);
export default __webpack_public_path__ + "static/media/The contact.76ed947ab7135512d18723ec110360fa.svg";
export { ForwardRef as ReactComponent };